import type { TelegramUserMeResponseDto, TelegramSellerPublicProfileResponseDto } from '@/generated';

const MAKLER_FLAG_KEY = 'makler';

export function isCompanyDataAllowed(userData?: Pick<TelegramUserMeResponseDto, 'isBusiness'>): boolean {
  return !!userData?.isBusiness;
}

export function isMaklerUser(userData?: Pick<TelegramUserMeResponseDto, 'flags'>): boolean {
  return !!userData?.flags?.some((f) => f.flag.key === MAKLER_FLAG_KEY && f.value);
}

export function isMaklerSellerPublicProfile(
  profile?: Pick<TelegramSellerPublicProfileResponseDto, 'businessFlagKeys'>,
): boolean {
  return !!profile?.businessFlagKeys?.includes(MAKLER_FLAG_KEY);
}

export const ABOUT_ME_MAX_LENGTH = 2000;
export const COMPANY_NAME_MAX_LENGTH = 255;
